var _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComprehensiveStrategy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3899_260)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3899_260",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 0H0V70H70V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7266 59.0625C35.4812 59.0625 36.0937 59.675 36.0937 60.4297C36.0937 61.1844 35.4812 61.7969 34.7266 61.7969C33.9719 61.7969 33.3594 61.1844 33.3594 60.4297C33.3594 59.675 33.9719 59.0625 34.7266 59.0625Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3899_260)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3899_260",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H70V70H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3899_260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7266 59.0625C35.4812 59.0625 36.0937 59.675 36.0937 60.4297C36.0937 61.1844 35.4812 61.7969 34.7266 61.7969C33.9719 61.7969 33.3594 61.1844 33.3594 60.4297C33.3594 59.675 33.9719 59.0625 34.7266 59.0625Z",
    fill: "#FF8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5193 1.36719C35.7751 1.36719 37.5976 3.19649 37.5976 5.45234V10.4863C41.0621 11.0811 44.2763 12.7381 46.7906 15.2687C48.8277 17.3182 50.3439 19.827 51.0193 22.5326C53.2314 31.3811 51.3255 36.493 49.4224 42.5154C49.2912 42.9311 49.1599 43.3508 49.03 43.7773C48.3505 46.0004 48.1591 48.6951 48.9726 51.4062",
    stroke: "#FF8C8C",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6884 28.7624C39.6567 29.7659 37.405 30.4618 34.7403 29.3284C34.5804 29.2614 34.4204 29.1863 34.2577 29.1055C28.413 26.1838 24.645 31.6827 24.1542 31.9752C22.5587 33.5708 19.972 33.5708 18.3778 31.9752L15.0296 28.6285C13.9618 27.5606 13.9618 25.8284 15.0296 24.7606L21.2653 18.5249C21.2653 14.0131 24.8829 10.3559 29.3946 10.3559V1.36665H32.8386",
    stroke: "#FF8C8C",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7403 29.3289C33.3608 32.0893 31.3456 34.5352 28.8095 36.4369C24.2745 39.8371 21.4075 45.2389 20.8511 50.8185V51.4062",
    stroke: "#FF8C8C",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4333 42.5195H57.7007C59.4616 36.8648 61.079 30.29 58.6522 20.5789C55.8946 9.54707 45.2114 1.36719 36.3315 1.36719H32.8384",
    stroke: "#FF8C8C",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1953 60.4297H51.1328C51.5922 60.4297 52.042 60.468 52.4809 60.5404C56.3705 61.183 59.3359 64.5613 59.3359 68.6328H10.1172C10.1172 64.5613 13.0826 61.183 16.9723 60.5404C17.4111 60.468 17.8609 60.4297 18.3203 60.4297H29.2578",
    stroke: "#FF8C8C",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9531 60.4297V54.1406C16.9531 52.6299 18.1768 51.4062 19.6875 51.4062H49.7656C51.2764 51.4062 52.5 52.6299 52.5 54.1406V60.4297",
    stroke: "#FF8C8C",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8906 19.9609H30.625",
    stroke: "#FF8C8C",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3899_260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComprehensiveStrategy);
export default __webpack_public_path__ + "static/media/comprehensive-strategy.429f055cbaecbcf74744cf54e9081c10.svg";
export { ForwardRef as ReactComponent };